'use strict';

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import classNames from 'classnames';
import PlayImage from '../../../../CommonElements/PlayImage.jsx';
import CountDownNext from './CountDownNext.jsx';
import { exitFullscreen } from '../../../../../utils/fullscreen';
import { createImageProxyUrl } from '../../../../../utils/svtimage';
import { withRouter } from 'next/router';
import OpenModal from '../../../../VideoModal/OpenModal.tsx';

const BACKGROUND_COLORS = ['blue', 'green', 'purple'];

const COUNTDOWN_TIME = 7;

class NextEpisodeInfo extends Component {
    render() {
        const { title, autoPlaySetting, onChangedVideo } = this.props;
        const nextInfoClassNames = classNames('play_end-screen-next__count-down-info', {
            'play_end-screen-next__count-down-info--cancelled': autoPlaySetting,
            'play_end-screen-next__count-down-info--no-auto-play': !autoPlaySetting,
        });

        return (
            <div className="play_end-screen-next__left-container">
                {autoPlaySetting ? (
                    <CountDownNext
                        startCount={COUNTDOWN_TIME}
                        startDelay={1400}
                        onComplete={onChangedVideo}
                    />
                ) : (
                    <span className={nextInfoClassNames}>Nästa avsnitt</span>
                )}
                <span className="play_end-screen-next__divider" />
                <span className="play_end-screen-next__title">{title}</span>
            </div>
        );
    }
}

export class NextEpisode extends Component {
    constructor(props) {
        super(props);

        this.playLinkClicked = false;

        //randomize ken burns effect
        this.kenBurnsStartPoints = `${30 + Math.floor(Math.random() * 50)}% ${
            20 + Math.floor(Math.random() * 60)
        }%`;

        //randomize background color
        this.backgroundColor = BACKGROUND_COLORS[Math.floor(Math.random() * BACKGROUND_COLORS.length)];

        this.onPlayLinkClick = this.onPlayLinkClick.bind(this);
        this.onChangedVideo = this.onChangedVideo.bind(this);
    }

    componentDidMount() {
        if (window.navigator.userAgent.match(/iphone|ipad|ipod/i)) {
            exitFullscreen();
        }

        if (this.props.skipNextScreen) {
            this.props.setNextVideoIsBinge(true);
            this.onNextVideo();
        }
    }

    componentWillUnmount() {
        this.cancelOutAnimation();
    }

    cancelOutAnimation() {
        if (this.animateOutId) {
            clearTimeout(this.animateOutId);
        }
    }

    onChangedVideo() {
        if (this.playLinkClicked) {
            return false;
        }

        this.container.parentNode.classList.add('play_end-screen-next--out');

        //had to make this a timeout cause IE11 could not listen on transitionEnd-event on pseudoelement
        this.animateOutId = setTimeout(() => {
            this.props.setNextVideoIsBinge(true);

            this.onNextVideo();
        }, 700);
    }

    onPlayLinkClick() {
        this.playLinkClicked = true;
        this.cancelOutAnimation();
        this.props.setNextVideoIsBinge(false);
    }

    onNextVideo() {
        this.props.router.replace(
            {
                query: {
                    openModal: 'true',
                    modalId: this.props.nextVideoId,
                    titleSlug: this.props.router.query.titleSlug,
                },
            },
            this.props.nextVideoUrl,
            { shallow: true }
        );
    }

    render() {
        const {
            nextVideoUrl,
            nextVideoTitle,
            nextVideoPosterImageId,
            nextVideoPosterImageChanged,
            nextVideoPosterImageAltText,
            autoPlaySetting,
            nextVideoId,
        } = this.props;

        const imgSrc = createImageProxyUrl(nextVideoPosterImageId, nextVideoPosterImageChanged, 'wide', 675);
        const imgSrcSet = [
            createImageProxyUrl(nextVideoPosterImageId, nextVideoPosterImageChanged, 'wide', 245) + ' 245w',
            createImageProxyUrl(nextVideoPosterImageId, nextVideoPosterImageChanged, 'wide', 482) + ' 482w',
            imgSrc + ' 675w',
            createImageProxyUrl(nextVideoPosterImageId, nextVideoPosterImageChanged, 'wide', 1350) + ' 1350w',
        ];
        const imgSizes = '(min-width: 1431px) 100vw, (min-width: 1025px and max-width: 1430px) 85vw, 50vw';

        const containerClass = classNames(
            'play_end-screen-next__background',
            `play_end-screen-next__background--${this.backgroundColor}`
        );

        return (
            <div className="play_end-screen-next">
                <div className={containerClass} ref={(ref) => (this.container = ref)}>
                    <NextEpisodeInfo
                        title={nextVideoTitle}
                        autoPlaySetting={autoPlaySetting}
                        onChangedVideo={this.onChangedVideo}
                        router={this.props.router}
                        contextLocation={this.props.contextLocation}
                    />
                    <div className="play_end-screen-next__right-container">
                        <div
                            className="play_end-screen-next__background-image-container"
                            style={{ transformOrigin: this.kenBurnsStartPoints }}
                        >
                            <PlayImage
                                usePlaceholder={false}
                                src={imgSrc}
                                className="play_end-screen-next__background-image"
                                srcSet={imgSrcSet.join(',')}
                                sizes={imgSizes}
                                alt={nextVideoPosterImageAltText}
                            />
                        </div>
                        <OpenModal videoId={nextVideoId} videoUrl={nextVideoUrl}>
                            <a
                                className="play_end-screen-next__next-video-link"
                                onClick={this.onPlayLinkClick}
                            >
                                <span className="play_end-screen-next__play-button" role="button">
                                    <span className="svt_icon svt_icon--play" />
                                </span>
                            </a>
                        </OpenModal>
                    </div>
                </div>
            </div>
        );
    }
}

NextEpisode.propTypes = {
    autoPlaySetting: PropTypes.bool,
    onClick: PropTypes.func,
    cancelUrl: PropTypes.string,
    contextLocation: PropTypes.object,
    nextVideoUrl: PropTypes.string.isRequired,
    nextVideoTitle: PropTypes.string,
    nextVideoPosterImageId: PropTypes.string,
    nextVideoPosterImageChanged: PropTypes.number,
    nextVideoId: PropTypes.string,
};

export default withRouter(NextEpisode);
